import { randomId } from '@shared/utils/randomId.js';
import FloatingSelectV2 from './v2/FloatingSelectV2.jsx';
import { useEffect, useRef, useState } from 'react';
import KeyHandler from './KeyHandler.jsx';
import IconV2 from '@/components/v2/IconV2.jsx';
import { HiOutlineSparkles, LuText } from '@/components/react-icons/main';
import Input from './Input.jsx';
import Spinner from './Spinner.jsx';

const InputSelect = ({ activeOptions = [], options, placeholder = 'Search...', aiPlaceholder = 'Use AI...', onSave, loading }) => {
  const inputRef = useRef();
  const [value, setValue] = useState('');
  const [useAi, setUseAi] = useState(false);
  const triggerClass = randomId();
  const hasOptions = options?.length > 0 && !useAi;
  const filteredOptions = hasOptions //
    ? options //
        ?.filter((n) => n?.label?.toLowerCase()?.includes(value?.toLowerCase()))
        ?.filter((n) => (activeOptions?.length === 0 ? true : !activeOptions?.some(([key, label]) => n?.label === label)))
    : [];

  const handleSave = (val) => {
    const finalValue = val || value;
    if (!finalValue) {
      return;
    }

    onSave?.(finalValue, { useAi });
    setValue('');
    inputRef.current?.focus();
  };

  const handleInputSubmit = () => {
    const className = document.activeElement?.className;
    if (className?.includes('option-wrapper')) {
      inputRef?.current?.focus();
    } else if (className?.includes('comp-input')) {
      inputRef?.current?.click();
    }
  };

  const keyMapHandler = {
    save: () => {
      if (!hasOptions) {
        handleSave();
      }

      if (!value) {
        inputRef.current?.click();
        return;
      }

      document.querySelector(`#input-select-${triggerClass} .option-wrapper .option.highlighted`)?.click();
    },
    focus: () => {
      if (!hasOptions) {
        return;
      }

      document.querySelector(`#input-select-${triggerClass} .option-wrapper`)?.focus();
    },
    keyDown: (e) => {
      const blacklist = ['Enter', 'Tab'];
      if (blacklist.includes(e.key)) {
        return;
      }
      handleInputSubmit();
    }
  };

  const keyMap = {
    Enter: keyMapHandler.save,
    // Tab: keyMapHandler.focus,
    ArrowDown: keyMapHandler.focus,
    PageDown: keyMapHandler.focus
  };

  const handleAiClick = () => {
    setUseAi(!useAi);
    inputRef?.current?.focus();
  };

  useEffect(() => {
    if (hasOptions) {
      window.addEventListener('keydown', keyMapHandler.keyDown);

      return () => {
        window.removeEventListener('keydown', keyMapHandler.keyDown);
      };
    }
  }, []);

  return (
    <div className={`comp-input-select`} id={`input-select-${triggerClass}`}>
      <Input className={`${triggerClass} ${useAi ? 'use-ai' : ''}`} value={value} placeholder={useAi ? aiPlaceholder : placeholder} onChange={(e) => setValue(e.target.value)} ref={inputRef} />
      {hasOptions && <FloatingSelectV2 parentId={`input-select-${triggerClass}`} triggers={[`.${triggerClass}`]} options={filteredOptions} onChange={handleSave} matchTriggerWidth useSearch={false} />}
      <IconV2 className={`ai-icon ${!loading ? 'inactive' : ''}`} icon={loading ? Spinner : !useAi ? HiOutlineSparkles : LuText} title={loading ? 'Loading...' : useAi ? 'Use Plain Text' : 'Use AI'} onClick={!loading ? handleAiClick : undefined} />
      <KeyHandler keyMap={keyMap} target={inputRef} preventDefault={true} stopPropagation={true} />
    </div>
  );
};

export default InputSelect;
